import styled from "@emotion/styled";
import { MDSText } from "@/mds";
import { MDSPanelWidths } from "@/mds/foundations";

export const StyledWrapper = styled.header`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-top: ${({ theme }) => theme.spacing["4"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["7"]};
  user-select: none;

  @container mds-panel (max-width: ${MDSPanelWidths.narrow}px) {
    padding-inline: ${({ theme }) => theme.spacing["2"]};
  }
`;

export const StyledPrimaryText = styled(MDSText)`
  letter-spacing: 0.24px;
  text-transform: uppercase;
`;
